export const Capitalize = (str) => {
  const strings = str?.split(' ');
  const capitalized = strings?.map(
    (val) => `${val.charAt(0).toUpperCase() + val.slice(1)}`
  );

  return capitalized.join(' ') ?? '';
};
